import { memo } from "react";

// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import { FormattedMessage } from "react-intl";

// assets

import PersonIcon from "@mui/icons-material/Person";
import VpnKeyIcon from '@mui/icons-material/VpnKey';

import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AirplayIcon from "@mui/icons-material/Airplay";
// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const role = localStorage.getItem("role");

  const AllOther = {
    id: "sample-docs-roadmap",
    type: "group",
    role: "Admin",
    children: [
      {
        id: "user-detail",
        title: <FormattedMessage id="Users" />,
        type: "item",
        url: "/users",
        // icon: <img src={restaurantIcon} alt="restaurant icon" />,
        icon: PersonIcon,
        breadcrumbs: false,
      },
      {
        id: "invitation-code",
        title: <FormattedMessage id="Invitation Code" />,
        type: "item",
        url: "/invitation-code",
        // icon: <img src={restaurantIcon} alt="restaurant icon" />,
        icon: VpnKeyIcon,
        breadcrumbs: false,
      },

      // {
      //   id: "episode",
      //   title: <FormattedMessage id="Episodes" />,
      //   type: "item",
      //   url: "/episode",
      //   // icon: <img src={restaurantIcon} alt="restaurant icon" />,
      //   icon: FormatListBulletedIcon,
      //   breadcrumbs: false,
      // },
      // {
      //   id: "advertise",
      //   title: <FormattedMessage id="Advertises" />,
      //   type: "item",
      //   url: "/advertise",
      //   // icon: <img src={restaurantIcon} alt="restaurant icon" />,
      //   icon: AirplayIcon,
      //   breadcrumbs: false,
      // },
    ],
  };

  const menuItem = {
    items: [AllOther],
  };

  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default memo(MenuList);
